import React from "react"
import PropTypes from "prop-types"
import * as Icon from "react-feather"
import { uniqueId } from "lodash"
import {
  StyledSelectWrapper,
  StyledCheckValidation,
  StyledCrossValidation,
  StyledSelect,
  StyledSelectIcons,
  StyledTooltipWrapper,
  StyledTooltip,
  StyledHover,
} from "./partials"
import { StyledFieldWrapper } from "./partials/StyledField"
import IconV2 from "../icon-v2"

const Select = ({
  id,
  name,
  text,
  label,
  children,
  onChange,
  defaultValue,
  required,
  hidden,
  disable,
  isValid,
  isDark,
  loading,
  half,
}) => {
  const htmlId = uniqueId(id)

  //   let half = false
  //   if (name === "campus" || name === "startTerm") {
  //     half = true
  //   }

  return (
    <>
      <StyledFieldWrapper
        data-name="field-select"
        isDark={isDark}
        hidden={hidden}
        valid={isValid}
        loading={loading}
        half={half}
      >
        <div>
          {isValid === undefined || isValid === null ? (
            <IconV2 icon={"angle-down"} size={"12"} iconType={"far"} />
          ) : (
            <IconV2
              icon={isValid === false ? "exclamation-circle" : "check-circle"}
              size={"14"}
              iconType={"fas"}
            />
          )}
          <select
            id={htmlId}
            name={name}
            defaultValue={defaultValue}
            onChange={(e) => {
              if (id) {
                const { value, validity } = e.target
                const index = e.nativeEvent.target.selectedIndex
                onChange(id, {
                  value: value,
                  valid: validity.valid,
                  selectLabel: e.nativeEvent.target[index].text,
                })
              } else onChange(e)
            }}
            required={required}
            // disabled={loading ? "disabled" : disable}
          >
            <option value="" disabled="disabled">
              {text}
            </option>
            {children}
          </select>
          {label && <label htmlFor={htmlId}>{label}</label>}
          {name === "earlyAction" && (
            <>
              <StyledTooltipWrapper>
                <StyledHover>
                  <IconV2 icon={"question-circle"} />
                  <StyledTooltip>
                    <p>
                      Please choose how you are applying to Hult. Students who
                      consider Hult among their top choices for their
                      undergraduate studies and are prepared to confirm their
                      place by February 15th 2024 are a great fit to apply Early
                      Action. Regular Decision students have until May 1st to
                      confirm.
                    </p>
                  </StyledTooltip>
                </StyledHover>
              </StyledTooltipWrapper>
            </>
          )}
        </div>
        {isValid === false && <span>Cannot be blank</span>}
      </StyledFieldWrapper>
    </>
  )
}

Select.defaultProps = {
  id: "",
  text: "",
  label: "",
  defaultValue: "",
  onChange: () => {},
  children: [],
  hidden: false,
  required: false,
  disable: false,
  isValid: undefined,
  loading: false,
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  required: PropTypes.bool,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  isValid: PropTypes.bool,
  loading: PropTypes.bool,
}

export default Select
